import { OtpInput } from '@components/atomic/atoms';
import React from 'react';
import { Button } from 'react-bootstrap';

interface OtpProps {
	email: string;
	onInputChange: (otp: string) => void;
	isLoading: boolean;
	handleClick: () => void;
}

const Otp: React.FC<OtpProps> = ({ email, onInputChange, isLoading, handleClick }) => {
	return (
		<>
			<div>
				<div className="text-center">
					<h5
						style={{
							fontSize: '32px',
							fontWeight: 700,
							lineHeight: '28.8px',
						}}
						className="pb-3"
					>
						Ti abbiamo inviato il codice OTP
					</h5>
					{/** Testo informativo per inserimento del codice otp */}
					<p
						style={{
							fontSize: '18px',
							fontWeight: '400',
							lineHeight: '24px',
							// fontFamily: 'Barlow',
						}}
					>
						Inserisci il codice OTP inviato al tuo indirizzo{' '}
						{email
							.split('@')
							.map((part) => {
								if (!part) return '*******@*******';
								return `${part.slice(0, 3)}${Array.from({ length: Math.min(part.length - 3, 3) })
									.fill('*')
									.join('')}`;
							})
							.join('@')}{' '}
						per continuare.
						<br />
						<span style={{ fontWeight: 700 }}>Ricorda che il codice ha una validità di 5 minuti.</span>
					</p>
				</div>
			</div>
			<div>
				<div
				// className="pb-3"
				>
					<div
						style={{
							padding: '20px',
							boxShadow: '0px 0px 29px 0px #0000001C',
							borderRadius: '15px',
							// marginBottom: '3rem',
						}}
					>
						<p>Inserisci il codice OTP</p>
						<OtpInput
							onInputChange={(otp) => {
								onInputChange(otp);
							}}
						/>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
							}}
						>
							<p
								style={{
									fontSize: '18px',
									fontWeight: 400,
									lineHeight: '24px',

									// fontFamily: 'Barlow',
								}}
								className="pt-3"
							>
								Non hai ricevuto il codice?{' '}
							</p>
							<Button
								variant="link"
								disabled={isLoading}
								onClick={handleClick}
								style={{
									// color: 'rgb(8, 162, 170)',
									fontSize: '18px',
									fontWeight: 400,
									lineHeight: '24px',
									textTransform: 'none',
									// fontFamily: 'Barlow',
								}}
							>
								Invia di nuovo
							</Button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Otp;
